import { TextLink } from "./TextLink";
export { TextLink };
export default TextLink;
